<!-- Todo Main Sidebar (Filter) -->
<core-sidebar 
class="sidebar-left" 
name="todo-sidebar-main-one" 
overlayClass="body-content-overlay"
collapsibleSidebar="bs-gt-lg" *ngIf="(activeView$ | async) === 'chart_view' || (activeView$ | async) === 'graph_view'">
<!-- Main Sidebar -->
  <div class="main-sidebar sidebar documentMainSideBar">
    <div class="sidebar-content todo-sidebar">
      <div class="todo-app-menu pt-75 pb-75 documentMainSideBarScroll">
        <div class="sidebar-menu-list">
          
          <div class="list-group list-group-filters">
            <a class="list-group-item list-group-item-action" [ngClass]="{'active':  (activeView$ | async) === 'graph_view'}" (click)="toggleViews('graph_view')">
                <i size="18" class="me-50 feather icon-copy align-middle"></i>
                <span class="align-middle">General</span>
                <!-- <span class="align-middle">{{ t('General tab name (documents - data view) - General') }}</span> -->
              </a>
              <a class="list-group-item list-group-item-action" [ngClass]="{'active':  (activeView$ | async) === 'chart_view'}" (click)="toggleViews('chart_view')">
                <i size="18" class="me-50 feather icon-clock align-middle"></i>
                <span class="align-middle">Margin</span>
                <!-- <span class="align-middle">{{ t('Margin tab name (documents - data view) - Margin') }}</span> -->
              </a>
          </div>

        </div>
      </div>
    </div>
  </div>
<!--/ Main Sidebar -->
</core-sidebar>
<!--/ Todo Main Sidebar -->
<ng-scrollbar autoHeightDisabled="false" visibility="hover" class="documentChartViewinnerContainer">
    <section class="p-2 px-1 documentChartViewinnerWidthContainer">
        <div class="row">
            <!-- Donut Chart Starts -->
            <div class="col-lg-6 col-12 ps-1">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Status Overview</h4>
                        <p class="font-small-3">Show realtime status of all contracts</p>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-lg-12">
                                <div class="chartContainer">
                                    <apx-chart
                                    [series]="documentStatusOverview.seriesStatus"
                                    [chart]="documentStatusOverview.chart"
                                    [labels]="documentStatusOverview.labels"
                                    [title]="documentStatusOverview.title"
                                    [theme]="documentStatusOverview.theme"
                                    [dataLabels]="documentStatusOverview.dataLabels"
                                    [responsive]="documentStatusOverview.responsive"
                                    [tooltip]="documentStatusOverview.tooltip"
                                    [legend]="documentStatusOverview.legend">
                                    </apx-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--/ Donut Chart Starts -->
            <!-- Donut Chart Starts -->
            <div class="col-lg-6 col-12 pe-0">
                <div class="card">
                    <div class="card-header px-0">
                        <h4 class="card-title">Contracts Needing Attention</h4>
                        <p class="font-small-3">Gives you a glimt of documents that could need some attention</p>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-lg-12">
                                <div class="chartContainer">
                                    <apx-chart
                                    [series]="contractAttention.seriesStatus"
                                    [chart]="contractAttention.chart"
                                    [labels]="contractAttention.labels"
                                    [title]="contractAttention.title"
                                    [theme]="contractAttention.theme"
                                    [dataLabels]="contractAttention.dataLabels"
                                    [responsive]="contractAttention.responsive"
                                    [tooltip]="contractAttention.tooltip"
                                    [legend]="contractAttention.legend">
                                    </apx-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--/ Donut Chart Starts -->
        </div>
    
        <div class="row">
            <!-- Scatter Chart Starts  -->
            <div class="col-lg-12 col-12 pe-0">
                <div class="card">
                    <div class="card-header">
                        <div>
                            <h4 class="card-title mb-25">Sent & Accepted Over Time</h4>
                            <p>Shows you all sent and signed documents per day</p>
                        </div>
                    </div>
                    <div class="card-body pb-50">
                        <div class="">
                            <apx-chart
                            [series]="overTimeChart.seriesOverTime"
                            [chart]="overTimeChart.chart"
                            [xaxis]="overTimeChart.xaxis"
                            [stroke]="overTimeChart.stroke"
                            [labels]="overTimeChart.labels"
                            [title]="overTimeChart.title"
                            [legend]="overTimeChart.legend"
                            [dataLabels]="overTimeChart.dataLabels"
                            [title]="overTimeChart.title"
                            [yaxis]="overTimeChart.yaxis">
                            </apx-chart>
                        </div>
                    </div>
                </div>
            </div>
            <!--/ Scatter Chart Ends  -->
        </div>
        
    
        <!-- Horizontal Bar Chart Start -->
        <div class="row">
            <div class="col-xl-12 col-12 pe-0">
                <div class="card">
                    <div class="card-header">
                        <div class="header-left">
                            <h4 class="card-title">Status Overview Per User</h4>
                            <p>Shows you a status overview of all documents devided per user, in alphabetical order</p>
                        </div>   
                    </div>
                    <div class="card-body pb-50">
                        <div class="">
                            <apx-chart
                                [series]="overviewPerUser.overviewPerUserseries"
                                [chart]="overviewPerUser.chart"
                                [stroke]="overviewPerUser.stroke"
                                [dataLabels]="overviewPerUser.dataLabels"
                                [xaxis]="overviewPerUser.xaxis"
                                [colors]="overviewPerUser.colors"
                                [fill]="overviewPerUser.fill"
                                [yaxis]="overviewPerUser.yaxis"
                                [legend]="overviewPerUser.legend"
                                [tooltip]="overviewPerUser.tooltip"
                                [responsive]="overviewPerUser.responsive"
                                [plotOptions]="overviewPerUser.plotOptions"
                            ></apx-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--/ Horizontal Bar Chart End -->
    
        <!-- Horizontal Bar Chart Start -->
        <div class="row">
            <div class="col-xl-12 col-12 pe-0">
                <div class="card mb-0">
                    <div class="card-header">
                        <div class="header-left">
                            <h4 class="card-title">Sent & Accepted (per user)</h4>
                            <p>Get a better understanding of the close-rate per user the past week, month or year.</p>
                        </div>
                    </div>
                    <div class="card-body pb-0">
                        <div class="row float-end">
                            <div class="col-lg-12 col-12 pe-3">
                                <div class="btn-group" role="group" aria-label="Basic example">
                                  <button type="button" class="btn btn-outline-primary" rippleEffect>1 week</button
                                  ><button type="button" class="btn btn-outline-primary" rippleEffect>1 month</button
                                  ><button type="button" class="btn btn-outline-primary" rippleEffect>1 year</button>
                                </div>
                            </div>
                        </div>
                        <div class="">
                            <apx-chart
                                [series]="sentAndAccepted.sentAndAcceptedseries"
                                [chart]="sentAndAccepted.chart"
                                [stroke]="sentAndAccepted.stroke"
                                [dataLabels]="sentAndAccepted.dataLabels"
                                [xaxis]="sentAndAccepted.xaxis"
                                [colors]="sentAndAccepted.colors"
                                [fill]="sentAndAccepted.fill"
                                [yaxis]="sentAndAccepted.yaxis"
                                [legend]="sentAndAccepted.legend"
                                [tooltip]="sentAndAccepted.tooltip"
                                [responsive]="sentAndAccepted.responsive"
                                [plotOptions]="sentAndAccepted.plotOptions"
                            ></apx-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--/ Horizontal Bar Chart End -->
    </section>
</ng-scrollbar>